import React, { Component } from "react";
import { StaticQuery, graphql, Link} from 'gatsby'
import { translate } from "react-i18next"

import appstore from '../assets/images/appstore.svg'
import playstore from '../assets/images/playstore.svg'

class Apps extends Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
    this.state = 
    {
        message: "",
    };
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  render() {
    const { t } = this.props
    return (
      <StaticQuery
        query={graphql`
          query AppssssQuery {
            site {
              siteMetadata {
                shortTitle
                appstore
                playstore
              }
            }
          }
        `}
        render={data => (
                    <section id="two" className="cards-top cards-bg-white">
                        <div className="inner">
                          <header className="major">
                          <h2>{t("apps_title", "WFOW nun als App verfügbar")}</h2>
                          </header>

                          <p>{t("apps_text1", "Finde deinen Weg zu Frauen und ihren Orten von überall: Lade dir die WORLD FULL OF WOMEN App jetzt kostenlos im App Store und auf Google Play.")}</p>

                          <div className="store-wrapper">
                            <div className="store-first">
                              <a href={data.site.siteMetadata.appstore} target="_blank" className="image alt-fit">
                                <img className="store-images" src={appstore} alt="WFOW@AppStore" />
                              </a>
                            </div>
                            <div className="store-second">
                              <a href={data.site.siteMetadata.playstore} target="_blank" className="image alt-fit">
                                <img className="store-images" src={playstore} alt="WFOW@PlayStore" />
                              </a>
                            </div>
                          </div>

                          <hr/>

                          <p>{t("apps_beta_text", "Wenn du uns beim Testen neuer Versionen helfen möchtest, kannst du dich hier registrieren:")}</p>
                          <ul className="actions vertical">
                            <li><a href="https://testflight.apple.com/join/otpOpFyq" target="_blank" className="button next">{t("apps_beta_ios", "Für iOS anmelden")}</a></li>
                            <li><a href="https://play.google.com/apps/testing/com.worldfullofwomen.app" target="_blank" className="button next">{t("apps_beta_android", "Für Android anmelden")}</a></li>
                          </ul>
                      </div>
                      <br/><br/>
                    </section>
                )}
            />
        )
    }
} 

export default translate("Index")(Apps)